import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loader from "../components/Loader";

const ProtectedRoute = ({ roles }) => {
  const { user, adminUser, hydrated } = useAuth();
  const location = useLocation();

  if (!hydrated) return <Loader />;

  const isSuperAdminRoute = location.pathname.startsWith('/super-admin');

  if (isSuperAdminRoute) {
    if (!adminUser) {
      return <Navigate to="/super-admin/login" state={{ from: location }} replace />;
    }
    if (adminUser.role === "super-admin") {
      return <Outlet />;
    }
    return <Navigate to="/" replace />;
  } else {
    if (!user) {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (roles?.length > 0 && !roles.includes(user.role)) {
      return <Navigate to="/" replace />;
    }
    return <Outlet />;
  }
};

export default ProtectedRoute;
